import React from "react";
import { Button } from "@mui/material";

import { BillsRecalculationFilterQuery } from "api";
import { useDialogControls } from "components";

import {
  AppliedFiltersDisplay,
  BillsRecalculationModal,
} from "../bills-recalculation";

interface BillsRecalculationButtonProps {
  displayFilters: AppliedFiltersDisplay;
  queryParams: BillsRecalculationFilterQuery;
}

export const BillsRecalculationButton = ({
  displayFilters,
  queryParams,
}: BillsRecalculationButtonProps) => {
  const dialogControls = useDialogControls();

  return (
    <>
      <Button
        variant="contained"
        onClick={dialogControls.open}
        sx={{ width: "200px", height: "34px", borderRadius: "8px" }}
      >
        Recalculate Bills
      </Button>
      <BillsRecalculationModal
        isOpen={dialogControls.isOpen}
        onClose={dialogControls.close}
        displayFilters={displayFilters}
        queryParams={queryParams}
      />
    </>
  );
};
